/**
 * S6 · Why us (#why) — THE FEED homepage, design.md Part III.
 * The statue's thought bubble types while the notifications drop in, then
 * fades out once the fifth card has landed (+600ms). The statue never moves.
 * Everything else here is CSS driven by the shared reveal (`.in`).
 */
import { onReveal } from "./runtime";

/** last card's delay (4 × 140ms) + its 420ms drop + 600ms of "typing" */
const BUBBLE_MS = 4 * 140 + 420 + 600;

export function init(): void {
  const list = document.querySelector<HTMLElement>("#why .notifs");
  const bubble = document.querySelector<HTMLElement>("#why .why__typing");
  if (!list || !bubble) return;
  onReveal((el) => {
    if (el !== list) return;
    window.setTimeout(() => bubble.classList.add("is-done"), BUBBLE_MS);
  });
}
